<template>
    <div>

        <!--

        INCOMING IS BASICALLY:
            GET ME EVERYTHING WHICH IS COMING IN MY LOCATION FOR:
                1. DELIVERY TO CUSTOMER (EITHER VIA DELIVERY OR STORE PICKUP) (DROP_LOCATION = LOCATION_ID)
                2. COMING AS INVENTORY ITEM FROM VENDOR ORDER OR PURHCASE ORDER (TO BE ADDED) (LOCSUB = LOCATION_ID)

        -->
        <b-modal id="modal-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>

        <div style="width: 100%;">
            <div>
                <div>
                    <b-alert variant="secondary" show style="display: inline-block; vertical-align: top;">
                        <!-- <div style="display: inline-block; vertical-align: top;">
                            <date-picker
                            v-model="date_range"
                            format="MM-DD-YYYY"
                            valueType="format"
                            style="width: 220px; font-size: 15px; display: block;"
                            placeholder="DATE OR DATE RANGE"
                            range
                            ></date-picker>
                        </div> -->

                        <div v-if="this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id" style="display: inline-block; vertical-align: top;">
                            <b-form-select size="sm" :options="get_locations()" v-model="drop_location">

                                <template #first>
                                        <b-form-select-option  :value="null" disabled>-- COMING TO --</b-form-select-option>
                                    </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;">
                            <b-button variant="success" style="display: inline-block;" size="sm" @click="fetch_init2">SEARCH</b-button>
                        </div>
                    </b-alert>

                    <b-alert variant="primary" show style="display: inline-block; vertical-align: top; padding: 13px;" v-if="items.length >0">

                        <div style="display: inline-block; vertical-align: top; ">
                            <b-form-select v-model="selected_state" :options="states_dict" size="sm" style="width: 150px;">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- STATE --</b-form-select-option>
                                    <b-form-select-option :value="'open'">OPEN</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top; ">

                            <b-form-select v-model="picked_pickup_truck" :options="trucks" size="sm" style="width: 150px;">
                                <template #first>
                                    <b-form-select-option  :value="null" disabled>-- PICKUP TRUCK --</b-form-select-option>
                                </template>

                            </b-form-select>
                        </div>

                        <!-- <div style="display: inline-block; vertical-align: top; ">
                            <b-form-select v-model="picked_delivery_truck" :options="trucks" size="sm" style="width: 180px;">

                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- DELIVERY TRUCK --</b-form-select-option>
                                </template>

                            </b-form-select>
                        </div> -->

                        <div style="display: inline-block; vertical-align: top;">
                            <b-form-select v-model="picked_incoming_type" :options="incoming_types" size="sm" style="width: 250px;">

                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- INCOMING TYPE --</b-form-select-option>
                                </template>

                            </b-form-select>
                        </div>
                    </b-alert>

                    <!-- <b-card-text style="padding-left: 15px;">
                        <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='today'" @click="set_dates('today')">Today</b-button>
                        <b-button size="sm" variant="outline-danger"  :pressed="picked_date_range=='yesterday'" @click="set_dates('yesterday')">Yesterday</b-button>
                        <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='this_week'" @click="set_dates('this_week')">This Week</b-button>
                        <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='last_week'" @click="set_dates('last_week')">Last Week</b-button>
                        <b-button size="sm"  variant="outline-danger"  :pressed="picked_date_range=='this_month'" @click="set_dates('this_month')">This Month</b-button>
                        <b-button size="sm" variant="outline-danger"  :pressed="picked_date_range=='last_month'" @click="set_dates('last_month')">Last Month</b-button>
                    </b-card-text> -->



                </div>



                <!-- <b-alert variant="secondary" show>
                    <div style="display: block;">
                        <div style="display: inline-block; vertical-align: top;">
                            <div>SELECT YEAR</div>

                            <b-form-select size="lg" :options="years" v-model="year" style="width: 180px; font-size: 17px; font-weight: bold;">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- YEAR --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;" v-if="year">
                            <div>SELECT MONTH</div>

                            <b-form-select size="lg" :options="months" v-model="month" style="width: 180px; font-size: 17px; font-weight: bold;" v-on:change="get_incoming_dates_for_year_month">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- MONTH --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;" v-if="year && month">
                            <div>SELECT DATE</div>

                            <b-form-select size="lg" :options="dates" v-model="picked_date" style="width: 180px; font-size: 17px; font-weight: bold;" v-on:change="get_incoming_items_for_date">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- DATE --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>



                        <div style="display: inline-block; vertical-align: top; margin-left: 20px;" v-if="items.length >0">
                            <div>FILTER LOCATION</div>

                            <b-form-select size="lg" :options="packet.locations" v-model="picked_location_id" style="width: 180px; font-size: 17px; font-weight: bold;">
                                <template #first>
                                    <b-form-select-option :value="null">ALL</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;" v-if="items.length >0">
                            <div>FILTER PICKUP TRUCK</div>

                            <b-form-select size="lg" :options="packet.trucks" v-model="picked_pickup_truck" style="width: 180px; font-size: 17px; font-weight: bold;">
                                <template #first>
                                    <b-form-select-option :value="null">ALL</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;" v-if="items.length >0">
                            <div>FILTER DELIVERY TRUCK</div>

                            <b-form-select size="lg" :options="packet.trucks" v-model="picked_delivery_truck" style="width: 180px; font-size: 17px; font-weight: bold;">
                                <template #first>
                                    <b-form-select-option :value="null">ALL</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>



                    </div>
                </b-alert> -->
            </div>
        </div>


        <div style="width: 100%; max-height: 800px; overflow-y: scroll; padding: 5px; min-height: 200px;">
            <div>
                <div v-if="items_being_loaded == true">
                    <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="false">
                    </loading>

                </div>
                <div v-else>
                    <div v-if="items.length > 0">
                        <table style="width: 100%;">
                            <thead>

                                <tr>
                                    <td class="ipt_tdhr" style="width: 120px;" @click="sortby('invoice_id')">
                                        INVOICE #
                                    </td>

                                    <td class="ipt_tdhr" style="width: 150px;">
                                        DELIVERY DATE
                                    </td>

                                    <td class="ipt_tdhr" style="width: 200px;" @click="sortby('product_sku')">
                                        PRD SKU
                                    </td>

                                    <td class="ipt_tdhr" style="width: 250px;" @click="sortby('product_name')">
                                        PRD NAME
                                    </td>

                                    <!-- <td class="ipt_tdhr" style="width: 80px;" @click="sortby('is_special')">
                                        PRD TYPE
                                    </td>
 -->
                                    <td class="ipt_tdhr" style="width: 80px;" @click="sortby('order_type')">
                                        ORDER TYPE
                                    </td>

                                    <td class="ipt_tdhr" @click="sortby('quantity')">
                                        QTY
                                    </td>

                                    <td class="ipt_tdhr" style="width: 250px;" @click="sortby('locsub')">
                                        ITEM PICK FROM
                                    </td>

                                    <td class="ipt_tdhr" style="width: 250px;" @click="sortby('ship_locsub')">
                                        DROP LOC
                                    </td>

                                    <td class="ipt_tdhr" style="width: 250px;" @click="sortby('drop_locsub')">
                                        DELIVERY LOC
                                    </td>

                                    <td class="ipt_tdhr" @click="sortby('pickup_truck')">
                                        PICKUP TRUCK
                                    </td>

                                    <!-- <td class="ipt_tdhr" @click="sortby('truck')">
                                        DELIVERY TRUCK
                                    </td> -->

                                    <td class="ipt_tdhr" style="width:100px;" @click="sortby('state')">
                                        STATUS
                                    </td>

                                    <td class="ipt_tdhr">
                                        ACTION
                                    </td>
                                </tr>
                            </thead>

                            <tbody>

                                <tr v-for="item,idx in filtered" v-bind:key="idx">
                                    <td class="ipt_tdr">
                                        {{ item.invoice_id }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ item.delivery_date }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ item.product_sku }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ item.product_name }}
                                    </td>

                                   <!-- <td style="border: 1px solid black;">
                                        <div v-if="item.is_special">
                                            <b-alert show variant="danger" style="padding: 2px; font-size: 12px; text-align: center;">SPECIAL</b-alert>

                                        </div>
                                        <div v-else>
                                            <b-alert show variant="transparent" style="padding: 2px; font-size: 12px; text-align: center;">REGULAR</b-alert>
                                        </div>
                                    </td>
 -->
                                    <td style="border: 1px solid black;">
                                        <div v-if="item.order_type == 'home_delivery'">
                                            <b-alert show variant="primary" style="padding: 2px; font-size: 11px; text-align: center;">HD</b-alert>

                                        </div>
                                        <div v-else-if="item.order_type == 'store_pickup'">
                                            <b-alert show variant="warning" style="padding: 2px; font-size: 11px; text-align: center;">SP</b-alert>
                                        </div>

                                        <div v-else>
                                            {{item.order_type}}
                                        </div>
                                    </td>

                                    <td class="ipt_tdr">
                                        {{ item.quantity }}
                                    </td>

                                  <td class="ipt_tdr">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{item.locsub === "0" ? "MECCA WHOLESALE" : packet.locsubsdict[item.original_locsub || item.locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            {{item.locsub === "0" ? "MECCA WHOLESALE" : packet.locationsdict[item.original_locsub || item.locsub]}}
                                        </span>
                                    </td>

                                    <td class="ipt_tdr">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.locsubsdict[item.ship_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            {{packet.locationsdict[item.ship_locsub]}}
                                        </span>
                                    </td>

                                    <td class="ipt_tdr">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.locsubsdict[item.drop_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            {{packet.locationsdict[item.drop_locsub]}}
                                        </span>

                                    </td>
                                    <td class="ipt_tdr">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.trucksdict[item.pickup_truck]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            N/A
                                        </span>
                                    </td>
                                    <!-- <td class="ipt_tdr">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.trucksdict[item.truck]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            N/A
                                        </span>

                                    </td> -->
                                    <td style="border: 1px solid black;">
                                        <b-form-select
                                            size="sm"
                                            :style="{width: '100px'}"
                                            :options="states"
                                            v-model="item.state"
                                            v-on:change="update_invoice_item_state(item)"
                                            :disabled="packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK'"
                                        ></b-form-select >
                                    </td>

                                    <td class="ipt_tdr hidden-print" style="border: 1px solid black;">
                                        <button  @click="show_comments(item)">CMNT</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>


<script>
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import ItemComments from '@/components/importables/ItemComments'

    export default {
        name: "Incoming",
        components: {flatPickr, Loading, ItemComments, DatePicker},
        data: function(){
            let out = {
                items: [],
                date_range: [],
                picked_date_range: null,
                dates: [],
                drop_location: null,
                active_date:null,
                years: [
                    //{value: 2021, text: 2021},
                    {value: 2022, text: 2022},
                    {value: 2023, text: 2023},
                    {value: 2024, text: 2024},
                    {value: 2025, text: 2025},
                    {value: 2026, text: 2026},
                    {value: 2027, text: 2027},
                    {value: 2028, text: 2028},
                    {value: 2029, text: 2029},
                    {value: 2030, text: 2030},
                    {value: 2031, text: 2031},
                    {value: 2032, text: 2032},
                    {value: 2033, text: 2033},
                    {value: 2034, text: 2034},
                    {value: 2035, text: 2035},
                ],
                months: [
                    {value: 1, text: 1},
                    {value: 2, text: 2},
                    {value: 3, text: 3},
                    {value: 4, text: 4},
                    {value: 5, text: 5},
                    {value: 6, text: 6},
                    {value: 7, text: 7},
                    {value: 8, text: 8},
                    {value: 9, text: 9},
                    {value: 10, text: 10},
                    {value: 11, text: 11},
                    {value: 12, text: 12},
                ],
                year: null,
                month: null,
                picked_date: null,
                picked_location_id: null,
                picked_pickup_truck: null,
                // picked_delivery_truck: null,

                packet: {},
                items_being_loaded: false,
                dates_being_loaded: false,
                current_date: null,
                type: 'incoming',
                locsubs: [],
                locsub: null,
                states: mappings.states.map(function(d){  if(d.value == 4 || d.value == -4 || d.value == 5 || d.value == -5){d.disabled=false} else {d.disabled = true} return d;  }),
                states_outgoing_current: mappings.states,
                states_outgoing_new: mappings.states,
                states_dict: mappings.states_dict,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                comments_dict: {},
                sort_asc: true,
                trucks: [],
                incoming_types: [
                    {value: null, text: "ALL"},
                    {value: "CUSTOMER_ORDER", text: "CUSTOMER ORDER"},
                    {value: "STORE_TRANSFER_ORDER", text: "STORE TRANSFER ORDER"},
                ],
                picked_incoming_type: null,
                selected_state: "open",
            }
            return out;

        },
        computed: {
            filtered: function(){
                let that = this;
                return this.items.filter(function(d){
                    //console.log(d.data.final_eta, that.date_range)
                    return (
                        ((that.picked_pickup_truck) ? d.pickup_truck == that.picked_pickup_truck : true )
                        // &&
                        // ((that.picked_delivery_truck) ? d.truck == that.picked_delivery_truck : true )
                        &&
                        ((that.picked_incoming_type) ? d.incoming_type == that.picked_incoming_type : true )
                        &&
                        (
                          (that.selected_state && that.selected_state == "open")
                            ? d.state !== 1
                            : that.selected_state && that.selected_state != "open"
                            ? d.state == that.selected_state
                            : true
                      )
                    )
                })
            }
        },

        methods: {
            allowed: function(item){
                let status = true
                let allowed_item = this.allowed_item(item);
                let filtered_location = this.filtered_location(item);
                let filtered_pickup_truck = this.filtered_pickup_truck(item);
                // let filtered_delivery_truck = this.filtered_delivery_truck(item);

                if (allowed_item && filtered_location && filtered_pickup_truck){
                    status = true
                }
                else {
                    status = false
                }
                return status

            },
            allowed_item: function(item){
                let status = true;
                let userrole = this.packet.userDetails.userrole;
                let item_location_id = item.drop_location;

                if (userrole == "admin" || userrole == "officeuser") {
                    status = true;
                }
                else {
                    if (this.packet.userDetails.properties.location_id) {

                        let location_id = parseInt(this.packet.userDetails.properties.location_id);
                        if (location_id == item.item_location_id){
                            status = true
                        }
                        else {
                            status = false
                        }
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },

            filtered_location: function(item){
                let status = true;
                if (this.picked_location_id) {
                    if (item.drop_location == this.picked_location_id){
                        status = true;
                    }
                    else {
                        status = false;
                    }
                }
                console.log(item.drop_location, this.picked_location_id, status)
                return status
            },

            filtered_pickup_truck: function(item){
                let status = true;
                if (this.picked_pickup_truck) {
                    if (item.pickup_truck == this.picked_pickup_truck){
                        status = true;
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },

            // filtered_delivery_truck: function(item){
            //     let status = true;
            //     if (this.picked_delivery_truck) {
            //         if (item.truck == this.picked_delivery_truck){
            //             status = true;
            //         }
            //         else {
            //             status = false;
            //         }
            //     }
            //     return status
            // },

            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid= item.itemid;
                this.$bvModal.show("modal-comments");
            },
            update_invoice_item_state: function(item){
                let path = "/api/sales/update_invoice_item_state/"
                let that = this;

                //for now, do not process store transfer orders.
                if (item.incoming_type == 'STORE_TRANSFER_ORDER'){
                    return
                }

                let data = {invoice_id: item.invoice_id, itemid: item.itemid, state: item.state, changed_by: this.packet.userDetails.username, product_sku: item.product_sku, quantity: item.quantity}

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Success updating item state.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );

                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating item state.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsync(path, data, s, f);
            },
            // get_dates: function(){
            //     let path = ""
            //     let that = this;
            //     if (this.type == 'incoming'){
            //         path = "/api/sales/get_incoming_items_dates/"
            //     }
            //     else if(this.type == 'outgoing') {
            //         path = "/api/sales/get_outgoing_items_dates/"
            //     }

            //     if (!path){
            //         return
            //     }
            //     let data = {locsub: this.locsub}

            //     let s = function(response) {
            //         if (response.data.result){

            //             that.dates = response.data.result;
            //         }
            //         else {
            //             that.$bvToast.toast(
            //                 response.data.error,
            //                 {title: "Error", autoHideDelay: 1500, variant:"warning"}
            //             );
            //         }
            //         that.dates_being_loaded = false;
            //     }

            //     let f = function(error) {
            //         console.log(error)
            //         that.$bvToast.toast(
            //             "Error retrieving dates for the incoming items.",
            //             {title: "Error", autoHideDelay: 1500, variant:"danger"}
            //         );
            //         that.dates_being_loaded = false;
            //     }
            //     this.items = [];
            //     this.dates_being_loaded = true;
            //     this.active_date = null;
            //     Requestor.getSync(path, data, s, f);
            // },
            get_items_for_date: function(date){
                this.active_date = date.date;

                let that = this;
                let path = ""
                if (this.type == 'incoming'){
                    path = "/api/sales/get_incoming_items/"
                }
                else {
                    path = "/api/sales/get_outgoing_items/"
                }

                if (!path){
                    return
                }
                let data = {locsub: this.locsub, date: date.date}
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                    that.items_being_loaded = false;
                    that.get_batch_comments();
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching items for the date.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items = [];
                this.items_being_loaded = true;
                Requestor.getSync(path, data, s, f);
            },
            get_batch_comments: function(){
                // let items = this.items.map(function(d){
                //     return {invoice_id: d.invoice_id, itemid: d.itemid}
                // })

                let items = [];
                for (var i =0; i<this.items.length; i++){
                    for (var j=0; j<this.items[i].items.length; j++){
                        items.push(
                            {
                                invoice_id: this.items[i].items[j].invoice_id,
                                itemid: this.items[i].items[j].itemid,
                            }
                        )
                    }
                }
                let path = "/api/sales/get_batch_comments/"
                let data = {items: items};
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        //that.items = response.data.result;
                        //console.log(response.data.result);
                        let comments = response.data.result;
                        if (comments.length > 0){
                            that.comments_dict = Object.assign({}, ...comments.map((x) => ({[x.invoice_id+'|'+x.itemid]: x.n_comments})));
                            console.log(that.comments_dict);
                        }

                    }
                    else {
                        console.log(response.data.error)
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }

                let f = function(error){
                    that.$bvToast.toast(
                        "Error loading comments.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                Requestor.postAsync(path, data, s, f);
            },
            fetch_init2: function(d){
                let path = "/api/sales/get_incoming_items_for_date_range/"
                let that = this;
                let data = {date_range: this.date_range.filter(d => d !== null), drop_location: this.drop_location};

                if (!data.drop_location && this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id){
                    this.$vex.dialog.alert({
                        message: "PICK AN INCOMING LOCATION"
                    });
                    return
                }

                // if (data.date_range.length < 2){
                //     this.$vex.dialog.alert({
                //         message: "PICK A PROPER DATE RANGE"
                //     });
                //     return
                // }
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                this.items = [];
                Requestor.postSync(path, data, s, f);
            },
            get_incoming_items_for_date: function(){
                let path = "/api/sales/get_incoming_items_for_date/"
                let that = this;
                let data = {date: this.picked_date};
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                this.items = [];
                Requestor.postSync(path, data, s, f);
            },
            get_incoming_dates_for_year_month: function(){
                let path = "/api/sales/get_incoming_dates_for_year_month/"
                let that = this;
                let data = {year: this.year, month: this.month};
                if (this.packet.userDetails.properties.location_id){
                    data.location_id = this.packet.userDetails.properties.location_id;
                }
                let s = function(response) {
                    if (response.data.result){
                        that.dates = response.data.result;
                        that.dates = that.dates.map(function(d){
                            return {value: d.date, text: d.date + ' ('+d.nitems+')' }
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.dates_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming dates.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.dates_being_loaded = false;
                }

                this.dates = [];
                this.items = [];
                this.picked_date = null;
                this.picked_location = null;
                Requestor.postAsync(path, data, s, f);
            },
            fetch_prereqs: function(){
            },
            fetch: function(type){

                this.type = type;
                this.items = []
                this.dates = []
                this.active_date = null;
                //this.locations = [];
                this.locsub = null;
                //this.get_dates()
            },
            sortby: function(key,mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items,key,mapper)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items,key,mapper)
                }
                this.sort_asc = !this.sort_asc;
            },
            set_dates: function(value){
                let start = null;
                let end = null;

                if(value == 'today') {
                    start = moment().format("MM-DD-YYYY");
                    end = moment().format("MM-DD-YYYY");

                }
                if(value == 'yesterday') {
                    start = moment().add(-1, 'days').format("MM-DD-YYYY");
                    end = moment().add(-1, 'days').format("MM-DD-YYYY");
                }
                if(value == 'this_week') {
                    start = moment().startOf('week').format("MM-DD-YYYY");
                    end = moment().endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'last_week') {
                    start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'this_month') {
                    start = moment().startOf('month').format("MM-DD-YYYY");
                    end = moment().endOf('month').format("MM-DD-YYYY");
                }
                if(value == 'last_month') {
                    start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY");
                }



                if (start && end) {
                    this.date_range = [start , end]
                    this.picked_date_range = value;

                    //this.fetch_init()
                }
            },
            get_locations: function(){
                let output = [
                    {value: null, text: "PICK LOCATION", disabled: true}
                ];
                let user_location = this.packet.userDetails.properties.location_id;
                if (user_location){
                    output = this.packet.locations.filter(function(d){return d.value == user_location});
                }
                else {
                    output = output.concat(this.packet.locations.filter(function(d){return d.text != 'All' && d.value != 46 && d.value != 44}))
                }

                return output
            }


        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.trucks = this.packet.trucks;

            if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                    let userLocation = this.packet.locations.find(item => [this.packet.userDetails.properties.location_id].includes(item.value))
                    if (userLocation) {
                        this.drop_location = userLocation.value
                        this.fetch_init2();
                    }
            };
            //let that = this;
            // this.locsubs = this.packet.locations.filter(function(d){
            //     // if(that.packet.userDetails.userrole == "admin" || that.packet.userDetails.userrole == "warehouseuser" || that.packet.userDetails.userrole == "warehousemanager" ){
            //     //     return d
            //     // }
            //     // else {
            //     //     return that.packet.userDetails.properties.location_id == parseInt(d.value.split("|")[0]);
            //     // }


            //     if (that.packet.userDetails.properties.location_id != null){
            //         return
            //             (
            //             (that.packet.userDetails.properties.location_id == parseInt(d.value.split("|")[0]))
            //             ||
            //             d.is_main_warehouse == true
            //             )
            //     }
            //     else {
            //         if (that.packet.userDetails.userrole == "admin"){
            //             return d
            //         }
            //         else {
            //             return d.is_main_warehouse == true
            //         }
            //     }

            // });


            // if (this.packet.userDetails.userrole == "admin"){
            //     this.locsubs.splice(0, 0, {value: 'all', text: 'ALL'});
            // }
        }

    }

</script>

<style scoped>

    .ipt_tdr {
        background: none;
        text-align: center;
        font-size: 12px;
    }

    .ipt_tdhr {
        background: #343a40;
        color: white;
        font-weight: bold;
        text-align: center;
        font-size: 12px;
        border: 1px solid white;
    }
</style>



// WEBPACK FOOTER //
// src/components/IncomingOutGoing/Incoming.vue